<template>
  <div class="carRecordsInfoDialog">
    <el-dialog
      title="使用记录"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          v-loading="listLoading"
          :data="listPageUsage"
          border
          fit
          highlight-current-row
        >
          <el-table-column
            label="使用时间"
            prop="useTime"
            align="center"
            width="310"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime }} ~ {{ scope.row.useTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="使用原因"
            prop="useReasonName"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="申请人"
            prop="applyName"
            width="120"
            align="center"
          />
          <el-table-column
            label="描述"
            prop="content"
            align="center"
            width="200"
          />
        </el-table>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-button type="primary" @click="openAddCarRecordsInfoDialog()"
          >新增使用记录</el-button
        >

        <el-button @click="closeCarRecordsInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增使用记录"
      :visible.sync="addCarRecordsInfoDialogVisible"
      @close="closeAddCarRecordsInfoDialog"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="车牌号：">
          {{ this.selectCarRecordsInfo.carNum }}
        </el-form-item>

        <el-form-item label="车辆类型：">
          {{ this.selectCarRecordsInfo.carTypeName }}
        </el-form-item>

        <el-form-item label="使用时间：">
          <el-date-picker
            v-model="startEndTime"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: auto"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="使用原因：">
          <el-select
            placeholder="请选择使用原因"
            value-key="dictValue"
            v-model="useReason"
            style="width: 200px; margin-right: 10px"
          >
            <el-option
              v-for="item in this.useReasonList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="content"
            style="margin-top: 10px"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="申请人：">
          <div style="display: flex; flex-direction: row">
            <el-button @click="openAddPeople()">选择人员</el-button>

            <div
              v-if="this.selectPeopleList.length > 0"
              style="margin-left: 10px"
            >
              {{ this.selectPeopleList[0].id }}-{{
                this.selectPeopleList[0].name
              }}
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="addCarRecordsInfoSubmit()"
          >确 定</el-button
        >

        <el-button @click="closeAddCarRecordsInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>

    <add-people
      :addPeopleVisible="addPeopleDialogVisible"
      dialogTitle="选择申请人"
      :peopleList="selectPeopleList"
      :isLimit="true"
      @closeAddPeopleVisible="closeAddPeopleDialog"
      @submitPeople="submitAddPeopleDriver"
    />
  </div>
</template>

<style scoped lang="scss">
.carRecordsInfoDialog {
}
</style>

<script>
import {
  addUsage,
  getDictList,
  listPageUsage,
} from '@/api/equipmentmanagement';
import AddPeople from '@/components/AddPeople/index.vue';

export default {
  name: 'CarRecordsInfoDialog',
  components: { AddPeople },
  props: {
    carRecordsInfoDialogVisible: false,
    selectCarRecordsInfo: {},
  },
  watch: {
    carRecordsInfoDialogVisible(val) {
      if (val) {
        //请求接口
        this.getCarRecordsInfo();
      }
    },
  },

  computed: {
    visible: {
      get() {
        return this.carRecordsInfoDialogVisible;
      },
      set(val) {
        if (!val) {
          this.$emit('closeEvent');
        }
      },
    },
  },
  data() {
    return {
      listPageUsage: [],
      useReasonList: [],

      listLoading: false,

      //新增使用记录
      addCarRecordsInfoDialogVisible: false,
      useReason: null,

      startEndTime: null,
      content: '',

      addPeopleDialogVisible: false,
      selectPeopleList: [],
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: 'use_reason' });
      this.useReasonList = result.data.data;
    },

    closeCarRecordsInfoDialog() {
      this.visible = false;
    },
    getCarRecordsInfo() {
      let req = {
        carId: this.selectCarRecordsInfo.carId,
        carNum: this.selectCarRecordsInfo.carNum,
        carType: this.selectCarRecordsInfo.carType,
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };
      // console.log(req)
      listPageUsage(req).then((result) => {
        this.listPageUsage = result.data.data.records;
      });
    },
    openAddCarRecordsInfoDialog() {
      this.addCarRecordsInfoDialogVisible = true;
    },
    closeAddCarRecordsInfoDialog() {
      this.startEndTime = null;
      this.useReason = {};
      this.content = '';
      this.selectPeopleList = [];
      this.addCarRecordsInfoDialogVisible = false;
    },
    addCarRecordsInfoSubmit() {
      //提交请求

      if (this.startEndTime === null) {
        this.$message.error('请选择使用时间');
        return;
      }

      if (this.useReason === null) {
        this.$message.error('请选择使用原因');
        return;
      }
      if (this.selectPeopleList.length === 0) {
        this.$message.error('请选择申请人');
        return;
      }

      let endTime = this.startEndTime;

      let req = {
        applyId: this.selectPeopleList[0].id,
        applyName: this.selectPeopleList[0].name,
        carId: this.selectCarRecordsInfo.carId,
        content: this.content,
        useReason: parseInt(this.useReason.dictValue),
        useReasonName: this.useReason.dictName,
        useTime: this.startEndTime[1],
        createTime: this.startEndTime[0],
      };

      addUsage(req).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: '提交成功', type: 'success' });

          this.closeAddCarRecordsInfoDialog();

          this.getCarRecordsInfo();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
    openAddPeople() {
      this.addPeopleDialogVisible = true;
    },

    closeAddPeopleDialog() {
      this.addPeopleDialogVisible = false;
    },
    submitAddPeopleDriver(employeeRoleList) {
      this.selectPeopleList = employeeRoleList;
    },
  },

  created() {
    this.getDictList();
  },
};
</script>
